
import useScrollAnimation from '../../../hooks/useScrollAnimation';

export default function Hero() {
  const ref = useScrollAnimation();

  return (
    <section ref={ref} className="relative min-h-screen flex flex-col items-center justify-center bg-white overflow-hidden">
      {/* Background visual */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1200px] h-[1200px] rounded-full bg-gradient-to-b from-horizon/60 via-horizon/20 to-transparent blur-3xl opacity-70"></div>
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] rounded-full bg-gradient-to-tl from-sail/10 to-transparent blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-8 lg:px-12 text-center pt-32 pb-12">
        <div className="animate-on-scroll mb-6">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-horizon text-anchor text-[13px] font-medium">
            <span className="w-1.5 h-1.5 rounded-full bg-anchor"></span>
            Intelligent Systems for Modern Business
          </span>
        </div>

        <h1 className="animate-on-scroll text-5xl sm:text-6xl md:text-7xl lg:text-[84px] font-light text-navy mb-8 tracking-tight leading-[1.05]" style={{ transitionDelay: '0.1s' }}>
          A Rising<br />Perspective.
        </h1>

        <p className="animate-on-scroll text-base md:text-lg text-navy/50 max-w-2xl mx-auto mb-12 leading-relaxed font-light" style={{ transitionDelay: '0.2s' }}>
          We design calm, intelligent systems that bring clarity, control, and steady improvement to finance, healthcare, real estate, and service-based businesses.
        </p>

        <div className="animate-on-scroll flex flex-col sm:flex-row items-center justify-center gap-4" style={{ transitionDelay: '0.3s' }}>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-8 py-3.5 bg-navy text-white text-sm font-medium rounded-full hover:bg-navy/90 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Gain Clarity
          </a>
          <a
            href="#process"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#process')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-8 py-3.5 text-navy/70 text-sm font-medium rounded-full hover:text-navy hover:bg-drift transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            See How It Works
            <i className="ri-arrow-down-line text-base"></i>
          </a>
        </div>
      </div>

      {/* Hero visual — large immersive image */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-8 lg:px-12 pb-24">
        <div className="animate-on-scroll" style={{ transitionDelay: '0.45s' }}>
          <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-navy/8">
            <div className="w-full h-[320px] sm:h-[420px] md:h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/a341a8ae1691e429d9b3eb2b48fbd925.jpg"
                alt="SkySails AI intelligent systems visualization"
                title="SkySails AI - Intelligent operational systems"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-navy/20 via-transparent to-transparent"></div>
          </div>
        </div>
      </div>

      {/* Trusted by strip */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-8 pb-20">
        <div className="animate-on-scroll" style={{ transitionDelay: '0.55s' }}>
          <p className="text-[13px] text-navy/30 text-center mb-6 font-medium tracking-wide uppercase">Trusted across industries</p>
          <div className="flex items-center justify-center gap-10 md:gap-16 flex-wrap">
            {['Finance', 'Healthcare', 'Real Estate', 'Home Services'].map((name) => (
              <span key={name} className="text-sm font-medium text-navy/20 tracking-wide">{name}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
